import { State } from "../../../Reducers"
import { selectLastJobID } from "./onboarding"
import { isProcessing, isToBeReviewed } from "../../../Models/API/JobModel"
import { AppStatus } from "../../../Models/Client/AppStatus"
import { AppStatusCanoticCrowd } from "../../../Models/Client/AppStatusCanoticCrowd"
import { hasValue } from "../../../Models/Client/FetchState"

export function selectVolatileAppStatus(
    state: State,
    appID: string
): AppStatus | undefined {
    const instanceFetch = state.api.apps.apps.records.get(appID)
    const onboarding = state.api.interface.templateInstantiate

    if (
        !hasValue(instanceFetch) ||
        !instanceFetch.value.canoticCrowd ||
        onboarding === null ||
        onboarding.instanceID !== appID
    ) {
        return undefined
    }

    const jobID = selectLastJobID(state)
    const jobFetch =
        jobID === undefined
            ? undefined
            : state.api.jobs.table[appID]?.records.get(jobID)

    if (hasValue(jobFetch)) {
        if (isToBeReviewed(jobFetch.value)) {
            return AppStatusCanoticCrowd.reviewRequired
        }

        if (isProcessing(jobFetch.value)) {
            return AppStatusCanoticCrowd.labeling
        }
    }

    if (onboarding.jobAttempts.length === 0) {
        return undefined
    }

    const lastOnboardingJobID =
        onboarding.jobAttempts[onboarding.jobAttempts.length - 1]

    if (lastOnboardingJobID === undefined || !hasValue(jobFetch)) {
        return AppStatusCanoticCrowd.labeling
    }

    return undefined
}
